import { IItemList } from "../components/core/Select";
import { ITab } from "../components/manage/Tabs";

export const TYPE_NUMBER_GIF = 1;
export const TYPE_NUMBER_IMAGE = 2;

export const MANAGE_SORT_LIST: IItemList[] = [
  {
    label: "Latest",
    value: "recent"
  },
  {
    label: "Views",
    value: "best"
  },
  {
    label: "Trending",
    value: "trending"
  },
  {
    label: "Oldest",
    value: "oldest"
  },
];

export const MANAGE_TABS: ITab[] = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "g",
    label: "GIFs",
  },
  {
    value: "i",
    label: "Images",
  },
  {
    value: "a",
    label: "Galleries",
  }
];

export const MANAGE_PAGE_SIZE: IItemList[] = [
  {
    label: "25 per page",
    value: "25"
  },
  {
    label: "50 per page",
    value: "50"
  },
  {
    label: "100 per page",
    value: "100"
  },
];

export const PUBLIC_LIST: IItemList[] = [
  {
    label: "All",
    value: null
  },
  {
    label: "Private",
    value: "0"
  },
  {
    label: "Public",
    value: "1"
  },
];

export const PROFILE_UPDATE_FIELDS_PATHS = {
  name: "/name",
  description: "/description",
  profile_url: "/profile_url",
  email: "/email",
  password: "/password",
  preferences: "/preferences",
  social: "/social"
};
